import { addWeeks } from '@common/utility/datetime';
import { Dividend } from '@services/appsync/types';
import * as Types from '../../types';

const markMonthChanges = (data: Types.ChartBar[]) => {
  for (let i = 0; i < data.length; i++) {
    if (i > 0) {
      if (data[i].date.getMonth() !== data[i - 1].date.getMonth()) {
        data[i].showMonth = true;
      }
    } else {
      if (data.length > 1 && data[i].date.getMonth() !== data[i + 1].date.getMonth()) {
        data[i].showMonth = true;
      }
    }
  }
};

/** Create chart bars from a dividends */
export const createBarsFromDividends = (dividends: Dividend[], maxBars: number): Types.ChartBar[] => {
  let barsWithData: Types.ChartBar[] = [];

  if (dividends.length === 0) {
    const lastDataDate = new Date('2023-04-02');
    barsWithData.unshift({ date: lastDataDate, dividend: null });
    for (let i = 1; i < maxBars - dividends.length; i++) {
      barsWithData.unshift({ date: addWeeks(lastDataDate, -i), dividend: null });
    }
  } else {
    barsWithData = dividends
      // asc order
      .sort((a, b) => (new Date(a.issued_at) < new Date(b.issued_at) ? -1 : 1))
      // get last x records
      .slice(-maxBars)
      // convert to ChartBar
      .map((d) => ({
        date: new Date(d.issued_at),
        dividend: d,
      }));

    if (dividends.length < maxBars) {
      const lastDataDate = barsWithData[0].date;
      for (let i = 1; i <= maxBars - dividends.length; i++) {
        barsWithData.unshift({ date: addWeeks(lastDataDate, -i), dividend: null });
      }
    }
  }
  markMonthChanges(barsWithData);
  return barsWithData;
};
